import React from 'react';
import { motion } from 'framer-motion';

const stats = [
  { label: 'Total Sales Volume', value: '$1.4B+', color: 'bg-tropical-500' },
  { label: 'Properties Sold', value: '1,500+', color: 'bg-caribbean-500' },
  { label: 'Client Satisfaction', value: '100%', color: 'bg-brand-accent' },
];

const StatsSection = () => {
  return (
    <section className="py-24 bg-gray-100 border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="relative p-8 rounded-3xl bg-white border border-gray-100 overflow-hidden group hover:shadow-2xl transition-all duration-500 shadow-xl"
            >
              <div className="relative z-10">
                <p className="text-sm font-semibold text-gray-500 uppercase tracking-widest mb-2 font-display">
                  {stat.label}
                </p>
                <h3 className="text-5xl font-bold text-ink-900 font-display tracking-tighter">
                  {stat.value}
                </h3>
              </div>
              
              {/* Decorative element */}
              <div className={`absolute bottom-0 right-0 w-32 h-32 ${stat.color} opacity-5 blur-3xl -mr-16 -mb-16 rounded-full group-hover:opacity-20 transition-opacity duration-500`} />
              <div className={`absolute top-0 left-0 w-1 h-full ${stat.color} opacity-0 group-hover:opacity-100 transition-opacity duration-500`} />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
